import React from "react";
import MyRouter from "routers/index";
import { Provider } from "react-redux";
import bookingReducer from "features/bookingSlice";
import auth from "features/auth";
import { configureStore } from "@reduxjs/toolkit";
import { ToastContainer } from "react-toastify";
import { persist, store } from "features/store";
import { PersistGate } from "redux-persist/integration/react";
import LoaderModal from "components/Loader/Loader";

// const store = configureStore({
//   reducer: {
//     booking: bookingReducer,
//     // selectedBooking: selectedBookingReducer,
//     auth: auth,
//   },
//   // to fix the problem from redux-persist. redux-toolkit
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
// });

function App() {
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persist}>
          <ToastContainer />
          <LoaderModal />
          <MyRouter />
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
